import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatRoleName } from 'utils/formatters';
import ResetPasswordIcon from 'components/atoms/icons/resetPasswordIcon';

const PatientRow = ({ data, selectEmail }) => (
  <tr>
    <td data-label="Full Name">
      <div className="adminPanel__row">
        <Link data-cy="adminPanel__user-link" to={`/admin/user/${data.guid}`}>
          <strong>{`${data.firstName} ${data.lastName}`}</strong>
        </Link>
      </div>
    </td>
    <td data-label="Role">
      <div className="adminPanel__row">
        {data.roles.map(({ name }) => formatRoleName(name)).join(', ')}
      </div>
    </td>
    <td data-label="Clinic">
      <div className="adminPanel__row adminPanel__row--scroll">
        {data.clinics.join(', ')}
      </div>
    </td>
    <td data-label="Email">
      <div className="adminPanel__row">{data.email}</div>
    </td>
    <td data-label="Reset Email">
      <div className="button-wrapper">
        <button
          className="adminPanel__row adminPanel__row--clickable"
          onClick={() => {
            selectEmail(data.email);
          }}
        >
          <ResetPasswordIcon />
        </button>
      </div>
    </td>
    <td data-label="Status">
      <div className="adminPanel__row">
        {data.status
          ? data.status.charAt(0).toUpperCase() + data.status.slice(1)
          : 'Active'}
      </div>
    </td>
  </tr>
);

PatientRow.propTypes = {
  data: PropTypes.shape().isRequired,
  selectEmail: PropTypes.func.isRequired,
};

export default PatientRow;
